import { useAuth0 } from '@auth0/auth0-react'
import { Button, SxProps } from '@mui/material'
import { removeLocalStorageItems } from '~utils/remove-local-storage-items'

const LogoutButton = ({ wide, sx }: { wide?: boolean; sx?: SxProps }) => {
  const { logout } = useAuth0()

  return (
    <Button
      sx={{
        width: wide ? '200px' : 'auto',
        ...sx,
      }}
      variant="contained"
      onClick={() => {
        removeLocalStorageItems()
        logout({ logoutParams: { returnTo: window.location.origin } })
      }}
    >
      Log Out
    </Button>
  )
}

export default LogoutButton
